import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Spinner from '../../../components/Spinner';
import TeamSettingsBody from '../../../components/client/TeamSettingsBody';
import TeamAdminOnly from '../../../components/client/TeamAdminOnly';

import '../../../App.scss';
import 'antd/dist/antd.css';

export default class TeamNewSettingsScreen extends Component {
    constructor(props) {
        super(props);

        const clientId = this.props.match.params.clientId;
        const teamId = this.props.match.params.teamId;
        const isAdmin = !!props.isAdmin;

        this.baseURLs = props.baseURLs || {
            teamDetails: `/client/manage/${clientId}/teams/${teamId}`
        };

        this.clientId = clientId;
        this.teamId = teamId;

        this.state = {
            teamId: teamId,
            clientId: clientId,
            loading: false,
            route: null,
            isAdmin,
        };
    }


    componentDidMount() {
    }

    componentWillUnmount() {
    }

    isLoading = () => {
        return this.state.loading || false;
    }

    renderRedirect = () => {
        const {route} = this.state;
        const clientId = this.clientId;
        const teamId = this.teamId;
        if (route && clientId && teamId && this.baseURLs.manage) {
            const toRoute = `${this.baseURLs.manage}/${clientId}/teams/${teamId}/${route}`;
            return <Redirect push to={toRoute}/>
        } else if (route && clientId && teamId && this.baseURLs.teamDetails) {
            const toRoute = `${this.baseURLs.teamDetails}/${route}`;
            return <Redirect push to={toRoute}/>
        } else {
            return null;
        }
    }

    render() {
        const redirected = this.renderRedirect();
        if (redirected) {
            return redirected;
        }

        if (!this.state.loading) {
            return (
                <div style={{height: '100%', textAlign: 'center', width: '100%'}}>
                    <TeamAdminOnly teamId={this.state.teamId} backTo={this.baseURLs.teamDetails}>
                        <TeamSettingsBody teamId={this.state.teamId} isAdmin={this.state.isAdmin} changedByClientId={this.state.clientId} />
                    </TeamAdminOnly>
                </div>
            );
        } else {
            return (
                <div style={{height: '100%', textAlign: 'center'}}>
                    <Spinner condition={() => { return this.isLoading() }} />
                </div>
            );
        }
    }
}
